import { ArrowDropDownOutlined } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails, Dialog, useTheme, useMediaQuery } from '@mui/material';
import * as React from 'react';

const StyledDialog = ({
    children,
    open,
    ...props
  }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
    <Dialog
        fullScreen={isMobile}
        fullWidth
        open={open}
        maxWidth={'md'}
        {...props}
    >
        {children}
    </Dialog>
    
   
)}

export default StyledDialog;